import type { GenericObject } from '../../types/genericTypes';

const EMAIL_LOCAL_PART = /^(?:[^<>()[\]\\.,;:\s@"]+(?:\.[^<>()[\]\\.,;:\s@"]+)*|".+")$/;
const EMAIL_DOMAIN_IP = /^\[(?:\d{1,3}\.){3}\d{1,3}\]$/;
const EMAIL_DOMAIN_HOST = /^(?:[a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}$/;
const EMAIL_BACKEND = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const isStandardEmail = (email: string): boolean => {
  const atIndex = email.lastIndexOf('@');
  if (atIndex <= 0 || atIndex === email.length - 1) return false;
  const local = email.slice(0, atIndex);
  const domain = email.slice(atIndex + 1);
  return EMAIL_LOCAL_PART.test(local) && (EMAIL_DOMAIN_IP.test(domain) || EMAIL_DOMAIN_HOST.test(domain));
};

export const validateEmail = (email: string, isMember = false) => {
  const normalized = String(email).toLowerCase();
  if (isMember) {
    return EMAIL_BACKEND.test(normalized);
  }
  return isStandardEmail(normalized);
};

export const isEmptyObject = (obj: GenericObject) => {
  return Object.keys(obj).length === 0;
};
